export default "Bez problémov, pobyt sme si užili :)";